import { getMockComments } from '@/mock/StudentComments';
import { fsumClient } from '@/services/FsumHttpClient';
import type FlightSchool from '@/types/FlightSchool';
import type FlightSchoolCourse from '@/types/FlightSchoolCourse';
import type { FlightSchoolCourseStudent } from '@/types/FlightSchoolStudent';
import type { StudentCommentResponse } from '@/types/Response/StudentCommentResponse';
import type { StudentCommentRequest } from '@/types/Request/StudentCommentRequest';

async function getMockStudentComments(): Promise<StudentCommentResponse[]> {
    return Promise.resolve(getMockComments());
}

async function getStudentComments(
    school: FlightSchool,
    course: FlightSchoolCourse,
    student: FlightSchoolCourseStudent,
): Promise<StudentCommentResponse[]> {
    return fsumClient.get(`/v1/flight-schools/${school.id}/courses/${course.certificate.uuid}/students/${student.id}/ratings/${student.ratingUuid}/student-comments`);
}

async function addStudentComment(
    school: FlightSchool,
    course: FlightSchoolCourse,
    student: FlightSchoolCourseStudent,
    comment: StudentCommentRequest,
): Promise<StudentCommentResponse> {
    return fsumClient.post(`/v1/flight-schools/${school.id}/courses/${course.certificate.uuid}/students/${student.id}/ratings/${student.ratingUuid}/student-comments`, comment);
}

async function deleteStudentComment(
    school: FlightSchool,
    course: FlightSchoolCourse,
    student: FlightSchoolCourseStudent,
    id: number,
): Promise<void> {
    return fsumClient.delete(`/v1/flight-schools/${school.id}/courses/${course.certificate.uuid}/students/${student.id}/ratings/${student.ratingUuid}/student-comments/${id}`);
}

export default {
    getMockStudentComments,
    getStudentComments,
    addStudentComment,
    deleteStudentComment,
};
